




import React, { useState, useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'


import LocalStorageService from '../../../services/LocalStorageService'

// Appt Components
import Box from '../../../components/simple/box/Box'
import Divider from '../../../components/simple/divider/Divider'

import { VerticalTimeline }  from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';

import ReportService from '../../../services/ReportService.js'
import TimelineCard from '../../../components/compound/timeline/TimelineCard.js'
import PulseLoader from 'react-spinners/PulseLoader.js'

function Overview (props) {
  const navigate = useNavigate()

  const [reportData, setReportData] = useState({})
  const [loading, setLoading] = useState(false)

  const apiToken = LocalStorageService.get('apiToken')
  const activeOrg = LocalStorageService.get('activeOrg')
  const params = useParams()
  const userId = params.userid

  const goBack = () => {
      navigate(-1)
  }     

  useEffect(() => {
      (async () => {
          if (!userId) { return }
          
          setLoading(true)
          await loadReport()
          setLoading(false)

      })()
  }, [userId])


  const loadReport = async () => {
  
      let responses = await ReportService.getReport(
          apiToken,
          { 
              orgId: activeOrg.id,
              staffId: userId,
              // limit: 100,
              // page: 1
          },
          {
              submissionType: 'general',
              query: [
              ],
              reports: [
                  "staffActivitySummary"
              ],
          },
      )
    
      setReportData(responses)
  
    }

  return (
    <Box gridArea='main' background='white' direction='column' gap='small' round='small' margin={{ bottom: 'large' }}>
      <Divider color='primary' />
      <Box
        gap='small'
        round='small'
      > 

          {!loading && <VerticalTimeline lineColor='#ddd' >
            {reportData?.staffActivitySummary?.map(record => <TimelineCard record={record} />)}
          </VerticalTimeline>}

{/* 
            <Text>Overview Screen - to be built</Text>
            <Text>{JSON.stringify(reportData)}</Text>
        </>} */}
        {loading && <Box align='center' pad={{ vertical: 'medium' }}>
          <PulseLoader color='#ff8300' size={15} margin={5} />
        </Box>}
      </Box>
    </Box>
  )
}
export default Overview
